// extracted by mini-css-extract-plugin
export default {"accordionSummary":"NavSection_accordionSummary__5NgiV","accordion":"NavSection_accordion__XUu+g","accordionDetails":"NavSection_accordionDetails__kw8gF"};